import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import IncidentGroupPatternActions from './IncidentGroupPatternActions';
import type { IncidentGroup } from '../../services/incidentsApi';
import type { IncidentGroupPatternActionMode } from './IncidentGroupPatternActionDialog';
import { STEP0_LEGACY_PATTERN_ACTIONS_HINT } from '../../domain/incidents/groupedRepresentativeAuditCopy';
import { PATTERN_VOLUME_SIGNALS_DISCLAIMER } from '../../domain/incidents/incidentPatternVocabulary';
import type { IncidentDrawerDetailScope } from './incidentDrawerDetailTypes';

export function IncidentDrawerDetailStep0({ scope }: { scope: IncidentDrawerDetailScope }) {
  const s = scope as any;
  return (

    <>
    {s.selectedGroupContext && (s.selectedGroupContext as any).group_key && (
      <Box ref={s.drawerStep0Ref} sx={s.stepSectionSx('step0')}>
    <Paper variant="outlined" sx={s.drawerCardSx}>
      {!s.groupedReviewMode ? (
        <Typography sx={s.cardLabelSx}>{s.journeyPhaseTitleForStep('step0')} phase</Typography>
      ) : null}
      <Box sx={{ mt: 0.35, mb: 0.6 }}>
        {s.renderAuditStepHeading('step0', 'Step 0: Understand the risk context')}
      </Box>
      <Typography sx={{ fontSize: 28, fontWeight: 900, lineHeight: 1.1, color: '#0f3d75', mb: 0.85 }}>
        {s.relatedIncidentCount.toLocaleString()} pattern observations
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, mb: 0.75 }}>
        {s.groupedIncidentExplanation}
      </Typography>
      {s.groupedReviewMode ? (
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55, mb: 0.75, fontWeight: 600 }}>
          {PATTERN_VOLUME_SIGNALS_DISCLAIMER}
        </Typography>
      ) : null}
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55, mb: 0.75 }}>
        {s.representativeIncidentSummary}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 700, mb: 1.25 }}>
        {s.actionScopeSummary}
      </Typography>
      {!s.groupedReviewMode && s.selectedGroupKey && s.canManageGroupPatterns && s.onGroupPatternAction ? (
        <Box sx={{ mb: 1.25 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1, lineHeight: 1.55 }}>
            {STEP0_LEGACY_PATTERN_ACTIONS_HINT}
          </Typography>
          <IncidentGroupPatternActions
            group={s.selectedGroupContext as IncidentGroup}
            canManage={s.canManageGroupPatterns}
            busy={s.groupPatternActionBusy}
            onAction={(group, mode: IncidentGroupPatternActionMode) => s.onGroupPatternAction(group, mode)}
          />
        </Box>
      ) : null}
      {s.policyContext.length > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1, lineHeight: 1.55, opacity: 0.88 }}>
          {s.policyContext.map((item: { label: string; value: string }) => `${item.label}: ${item.value}`).join(' · ')}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
        <Button
          size="medium"
          variant="outlined"
          sx={{
            minHeight: 40,
            px: 2.1,
            borderRadius: 2.25,
            fontWeight: 800,
            letterSpacing: 0.3,
            textTransform: 'uppercase',
          }}
          onClick={s.openRelatedIncidents}
        >
          View pattern observations
        </Button>
        {s.groupedReasonText && (
          <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {s.groupedReasonText}
          </Typography>
        )}
      </Box>
    </Paper>
    {!s.groupedReviewMode ? s.renderStepNavigation('step0') : null}
      </Box>
    )}
    </>

  );
}
